import { useAsyncAddOrdersToVA } from 'features/VisualAssortment/api/hooks/mutations/useAsyncAddOrdersToVA'
import { useHasVAAccess } from 'features/VisualAssortment/api/hooks/queries/useHasVAAccess'

/**
 * HOC to inject Visual Assortment access and mutation hook
 * for use in Class components
 */
export const withVAAccess = (WrappedComponent: React.ComponentType<any>) => {
  const displayName =
    WrappedComponent.displayName || WrappedComponent.name || 'Component'

  const ComponentWithVAAccess = (props: any): JSX.Element => {
    const { hasVAAccess } = useHasVAAccess()
    const { asyncAddOrdersToVA } = useAsyncAddOrdersToVA()

    return (
      <WrappedComponent
        hasVAAccess={hasVAAccess}
        asyncAddOrdersToVA={asyncAddOrdersToVA}
        {...props}
      />
    )
  }

  ComponentWithVAAccess.displayName = `withVAAccess(${displayName})`

  return ComponentWithVAAccess
}
